import * as THREE from 'three';

/**
 * Shadow-pass depth material for plain `InstancedMesh` casters (docs/PERF.md "Phone pass").
 *
 * three draws every caster without a `customDepthMaterial` through ONE shared depth material, and its
 * per-material program record remembers whether the last draw was instanced. The shadow pass walks the
 * scene in graph order, so every change between a plain mesh and an InstancedMesh (the loose street
 * props, the crowd's limb batches) made three look its program up again: parameters gathered, the cache
 * key joined, a map lookup, each flip, every frame. A depth material of our own per instancing flavour
 * keeps each record steady. Same shader, same shadow: the map is a depth texture, so the packing is moot
 * (three's own is a bare `MeshDepthMaterial` too).
 */
const cache = new Map<string, THREE.MeshDepthMaterial>();

/** Shared depth material for an `InstancedMesh` caster; `colour` when it has an `instanceColor` buffer. */
export function instancedDepthMaterial(colour: boolean): THREE.MeshDepthMaterial {
  const key = colour ? 'colour' : 'plain';
  let m = cache.get(key);
  if (!m) {
    m = new THREE.MeshDepthMaterial();
    m.name = `instanced-depth-${key}`;
    cache.set(key, m);
  }
  return m;
}
